interface ErrorHeaderProps {
  message?: string;
}

export function ErrorHeader({
  message = "An error occurred",
}: ErrorHeaderProps) {
  return (
    <div className="bg-red-800/40 p-2 py-1 text-white w-full">
      <div className="overflow-x-auto whitespace-pre-wrap break-words text-2xs">
        {message}
      </div>
    </div>
  );
}

export default ErrorHeader;
